import { render, staticRenderFns } from "./PuzzleCreate.vue?vue&type=template&id=793c0b3d&"
import script from "./PuzzleCreate.vue?vue&type=script&lang=js&"
export * from "./PuzzleCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports